import React, { Component } from 'react';

import PaginationComponent from './PaginationComponent';
import { GENERAL_STATUS, RESTOCKING_PAYMENT_STATUS } from '../utils/enums';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { getSelectedBranchId } from '../utils/branch';
import { scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { getSearchEmptyMessage } from '../utils/tableState';

var config = process.env;

class AnalyticsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            quantityShowRowsPurchases: 25,
            quantityShowRowsRestockings: 25,
            currentPagePurchases: 1,
            currentPageRestockings: 1,
            totalPurchases: 0,
            totalRestockings: 0,
            searchPurchases: '',
            searchPurchasesInput: '',
            searchRestockings: '',
            searchRestockingsInput: '',
            sortByPurchases: 'date',
            sortDirPurchases: 'desc',
            sortByRestockings: 'date',
            sortDirRestockings: 'desc',
            purchases: [],
            restockings: [],
            itemName: '',
            loaded: false,
            statistics: {
                purchases: {
                    unitsSold: 0,
                    totalAmount: 0,
                    lastPurchaseDate: null,
                },
                restockings: {
                    unitsRestocked: 0,
                    firstRestockingDate: null,
                },
            },
        };
    }

    getSummaryCardStyle = () => ({
        borderRadius: '0.625rem',
        padding: '15px',
        minHeight: '114px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
    })

    getSummaryShimmerStyle = (extraStyle = {}) => ({
        backgroundColor: '#eef3f8',
        backgroundImage: 'linear-gradient(90deg, #eef3f8 0%, #f9fbfe 45%, #edf2f8 100%)',
        backgroundSize: '200% 100%',
        animation: 'summaryShimmer 1.35s linear infinite',
        boxShadow: 'inset 0 0 0 1px rgba(201, 211, 224, 0.12)',
        ...extraStyle,
    })

    componentDidMount() {
        this.fetchData();
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchPurchasesDebounceTimeout');
        clearDebouncedCallback(this, 'searchRestockingsDebounceTimeout');
    }

    buildQuery = ({
        purchasePage = this.state.currentPagePurchases,
        purchaseLimit = this.state.quantityShowRowsPurchases,
        purchaseSearch = this.state.searchPurchases,
        purchaseSortBy = this.state.sortByPurchases,
        purchaseSortDir = this.state.sortDirPurchases,
        restockingPage = this.state.currentPageRestockings,
        restockingLimit = this.state.quantityShowRowsRestockings,
        restockingSearch = this.state.searchRestockings,
        restockingSortBy = this.state.sortByRestockings,
        restockingSortDir = this.state.sortDirRestockings,
    } = {}) => {
        const params = new URLSearchParams();
        const selectedBranchId = getSelectedBranchId();

        params.set('purchasePage', String(purchasePage));
        params.set('purchaseLimit', String(purchaseLimit));
        params.set('purchaseSortBy', purchaseSortBy);
        params.set('purchaseSortDir', purchaseSortDir);
        params.set('restockingPage', String(restockingPage));
        params.set('restockingLimit', String(restockingLimit));
        params.set('restockingSortBy', restockingSortBy);
        params.set('restockingSortDir', restockingSortDir);

        if (purchaseSearch && purchaseSearch.trim() !== '') {
            params.set('purchaseSearch', purchaseSearch.trim());
        }
        if (restockingSearch && restockingSearch.trim() !== '') {
            params.set('restockingSearch', restockingSearch.trim());
        }
        if (selectedBranchId && selectedBranchId !== 'all') {
            params.set('branchId', selectedBranchId);
        }

        return params.toString();
    }

    fetchData = (nextState = {}) => {
        if (nextState.showLoader !== false) {
            this.setState({ loaded: false });
        }
        const query = this.buildQuery(nextState);
        const request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };

        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}analytics/product/${this.props.code}?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
                return;
            }

            const responseData = data.data;
            if (typeof this.props.onItemNameChange === 'function') {
                this.props.onItemNameChange(responseData.itemName || '');
            }
            this.setState({
                purchases: responseData.purchases || [],
                restockings: responseData.restockings || [],
                itemName: responseData.itemName || '',
                statistics: responseData.statistics || this.state.statistics,
                currentPagePurchases: Number(responseData.purchasesPagination?.page || nextState.purchasePage || this.state.currentPagePurchases),
                quantityShowRowsPurchases: Number(responseData.purchasesPagination?.limit || nextState.purchaseLimit || this.state.quantityShowRowsPurchases),
                totalPurchases: Number(responseData.purchasesPagination?.total || 0),
                searchPurchases: nextState.purchaseSearch != null ? nextState.purchaseSearch : this.state.searchPurchases,
                sortByPurchases: nextState.purchaseSortBy || this.state.sortByPurchases,
                sortDirPurchases: nextState.purchaseSortDir || this.state.sortDirPurchases,
                currentPageRestockings: Number(responseData.restockingsPagination?.page || nextState.restockingPage || this.state.currentPageRestockings),
                quantityShowRowsRestockings: Number(responseData.restockingsPagination?.limit || nextState.restockingLimit || this.state.quantityShowRowsRestockings),
                totalRestockings: Number(responseData.restockingsPagination?.total || 0),
                searchRestockings: nextState.restockingSearch != null ? nextState.restockingSearch : this.state.searchRestockings,
                sortByRestockings: nextState.restockingSortBy || this.state.sortByRestockings,
                sortDirRestockings: nextState.restockingSortDir || this.state.sortDirRestockings,
                loaded: true,
            });
        });
    }

    extractDateParts = (fecha) => {
        if (!fecha) {
            return '';
        }

        const parsedDate = new Date(fecha);
        if (Number.isNaN(parsedDate.getTime())) {
            return '';
        }
        const day = String(parsedDate.getDate()).padStart(2, '0');
        const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
        const year = parsedDate.getFullYear();
        return `${day}-${month}-${year}`;
    };

    drawPurchaseRow = (item, index) => {
        const date = this.extractDateParts(item.date);
        const finalPrice = item.price * (1 - item.discount / 100);
        const profit = (finalPrice - item.cost) * item.quantity;
        const profitPercentage = finalPrice === 0 ? 0 : (((finalPrice - item.cost) / finalPrice) * 100).toFixed(2);

        return(
            <tr role="row" className="odd" key={`purchase-${item.purchaseId}`} style={{ background: index % 2 == 0 ? '#ffffff' : '#fcfcfc' }}>
                <td>{item.purchaseId}</td>
                <td>{date}</td>
                <td>{item.name}</td>
                <td>{item.quantity}</td>
                <td>$ {item.price}</td>
                <td>{item.discount} %</td>
                <td>$ {finalPrice}</td>
                <td>$ {item.cost}</td>
                <td>$ {profit}</td>
                <td>{profitPercentage} %</td>
                <td>{GENERAL_STATUS[item.status]}</td>
            </tr>
        );
    }

    drawRestockingRow = (item, index) => {
        const date = this.extractDateParts(item.date);
        return(
            <tr role="row" className="odd" key={`restocking-${item.id}`} style={{ background: index % 2 == 0 ? '#ffffff' : '#fcfcfc' }}>
                <td>{item.id}</td>
                <td>{date}</td>
                <td>{item.quantity}</td>
                <td>{item.unitPrice}</td>
                <td>{item.provider}</td>
                {/* ENI-32: el estado sale de la factura linkeada. Sin factura, `paymentStatus`
                    viene null y `RESTOCKING_PAYMENT_STATUS[null]` es undefined: la celda quedaba
                    vacía, que se lee como "falta un dato" cuando en realidad es el caso normal de
                    la mercadería en consignación. Mismo guard que TableRestockingComponent. */}
                <td>
                    {item.providerInvoiceId
                        ? RESTOCKING_PAYMENT_STATUS[item.paymentStatus]
                        : <span className="text-muted" title="No tiene factura asociada, así que no genera deuda">Sin factura</span>}
                </td>
            </tr>
        );
    }

    loadPurchases = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.purchases.map((item, index) => this.drawPurchaseRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty-purchases"><td colSpan="11" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                    {getSearchEmptyMessage(this.state.searchPurchasesInput || this.state.searchPurchases)}
                </td></tr>
            );
        }

        return <tbody>{items}</tbody>;
    }

    loadRestockings = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.restockings.map((item, index) => this.drawRestockingRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty-restockings"><td colSpan="6" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                    {getSearchEmptyMessage(this.state.searchRestockingsInput || this.state.searchRestockings)}
                </td></tr>
            );
        }

        return <tbody>{items}</tbody>;
    }

    onChangeShowRowsPurchases = () => {
        const itemSelected = Number(document.getElementById('select_rows_pur').value);
        this.fetchData({ purchasePage: 1, purchaseLimit: itemSelected });
    }

    onChangeShowRowsRestocking = () => {
        const itemSelected = Number(document.getElementById('select_rows_res').value);
        this.fetchData({ restockingPage: 1, restockingLimit: itemSelected });
    }

    onChangeInputPurchases = (search) => {
        this.setState({ searchPurchasesInput: search });
        scheduleDebouncedCallback(this, 'searchPurchasesDebounceTimeout', () => {
            this.fetchData({ purchasePage: 1, purchaseSearch: search, showLoader: false });
        });
    }

    onChangeInputRestockings = (search) => {
        this.setState({ searchRestockingsInput: search });
        scheduleDebouncedCallback(this, 'searchRestockingsDebounceTimeout', () => {
            this.fetchData({ restockingPage: 1, restockingSearch: search, showLoader: false });
        });
    }

    orderPurchases = (column) => {
        this.fetchData({
            purchasePage: 1,
            purchaseSortBy: column,
            purchaseSortDir: nextSortDir(column, this.state.sortByPurchases, this.state.sortDirPurchases),
        });
    }

    orderRestockings = (column) => {
        this.fetchData({
            restockingPage: 1,
            restockingSortBy: column,
            restockingSortDir: nextSortDir(column, this.state.sortByRestockings, this.state.sortDirRestockings),
        });
    }

    // Las dos grillas ordenan por separado, cada una con su propio par (sortBy, sortDir) en el
    // state: la clase y el aria-sort se derivan de ahí, así sobreviven al remonte del loader.
    purchasesHeader = (column) => ({
        onClick: () => this.orderPurchases(column),
        className: sortClass(column, this.state.sortByPurchases, this.state.sortDirPurchases),
        'aria-sort': sortAriaSort(column, this.state.sortByPurchases, this.state.sortDirPurchases),
        tabIndex: '0',
    })

    restockingsHeader = (column) => ({
        onClick: () => this.orderRestockings(column),
        className: sortClass(column, this.state.sortByRestockings, this.state.sortDirRestockings),
        'aria-sort': sortAriaSort(column, this.state.sortByRestockings, this.state.sortDirRestockings),
        tabIndex: '0',
    })

    getDaysDifferenceNow = (date1) => {
        if (!date1) {
            return 0;
        }
        const time1 = new Date(date1).getTime();
        const time2 = new Date().getTime();
        const differenceInMilliseconds = Math.abs(time2 - time1);
        const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
        return differenceInDays.toFixed(0);
    }

    renderSummaryLoadingCard = (key, columnClassName) => {
        return (
            <div className={columnClassName} key={key}>
                <div className="card card-small mb-4" style={this.getSummaryCardStyle()}>
                    <div className="text-center" style={{ width: '100%' }}>
                        <div
                            className="mb-3 mx-auto summary-shimmer"
                            style={this.getSummaryShimmerStyle({
                                width: '68%',
                                minWidth: '120px',
                                height: '18px',
                                borderRadius: '999px',
                            })}
                        ></div>
                        <div
                            className="mx-auto summary-shimmer"
                            style={this.getSummaryShimmerStyle({
                                width: '42%',
                                minWidth: '84px',
                                height: '28px',
                                borderRadius: '10px',
                            })}
                        ></div>
                    </div>
                </div>
            </div>
        );
    }

    renderPurchasesStatistics = () => {
        if (!this.state.loaded) {
            return (
                <div className="row align-items-center justify-content-center">
                    {this.renderSummaryLoadingCard('summary-loading-1', 'col-md-3 col-sm-6')}
                    {this.renderSummaryLoadingCard('summary-loading-2', 'col-md-3 col-sm-6')}
                    {this.renderSummaryLoadingCard('summary-loading-3', 'col-md-3 col-sm-6')}
                    {this.renderSummaryLoadingCard('summary-loading-4', 'col-md-3 col-sm-6')}
                </div>
            );
        }

        const stats = this.state.statistics;
        const unitsSold = stats.purchases?.unitsSold || 0;
        const totalAmount = stats.purchases?.totalAmount || 0;
        const referenceDate = stats.purchases?.lastPurchaseDate || stats.restockings?.firstRestockingDate;
        const daysFromLastPurchase = this.getDaysDifferenceNow(referenceDate);

        return (
            <div className="row align-items-center justify-content-center">
                <div className="col-md-3 col-sm-6">
                    <div className="card card-small mb-4" style={this.getSummaryCardStyle()}>
                        <div className="row">
                            <div className="col">
                                <span className="text-muted d-block mb-2 text-center">Unidades vendidas</span>
                                <div className="col-md-12 d-flex align-items-center justify-content-center" style={{ gap: '3px', fontSize: '20px' }}>
                                    <span className="text-muted d-block mb-2">{unitsSold}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6">
                    <div className="card card-small mb-4" style={this.getSummaryCardStyle()}>
                        <div className="row">
                            <div className="col">
                                <span className="text-muted d-block mb-2 text-center">Monto total vendido</span>
                                <div className="col-md-12 d-flex align-items-center justify-content-center" style={{ gap: '3px', fontSize: '20px' }}>
                                    <span className="text-muted d-block mb-2">$ {Number(totalAmount).toLocaleString('de-DE')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6">
                    <div className="card card-small mb-4" style={this.getSummaryCardStyle()}>
                        <div className="row">
                            <div className="col">
                                <span className="text-muted d-block mb-2 text-center">Días desde la última venta</span>
                                <div className="col-md-12 d-flex align-items-center justify-content-center" style={{ gap: '3px', fontSize: '20px' }}>
                                    <span className="text-muted d-block mb-2">{daysFromLastPurchase}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-3 col-sm-6">
                    <div className="card card-small mb-4" style={this.getSummaryCardStyle()}>
                        <div className="row">
                            <div className="col">
                                <span className="text-muted d-block mb-2 text-center">Unidades compradas</span>
                                <div className="col-md-12 d-flex align-items-center justify-content-center" style={{ gap: '3px', fontSize: '20px' }}>
                                    <span className="text-muted d-block mb-2">{stats.restockings?.unitsRestocked || 0}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderPurchases = () => {
        return <div>
            <h5 style={{ color: '#3d5170', fontWeight: 600, marginBottom: '1rem' }}>Ventas</h5>
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows_pur" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRowsPurchases} onChange={() => this.onChangeShowRowsPurchases()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search_purchases" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchPurchasesInput} onChange={(e) => this.onChangeInputPurchases(e.target.value)}/>
                    </label>
                </div>
                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            <th {...this.purchasesHeader('purchaseId')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Venta</th>
                            <th {...this.purchasesHeader('date')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Fecha</th>
                            <th {...this.purchasesHeader('name')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '20%' }}>Cliente</th>
                            <th {...this.purchasesHeader('quantity')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Unidades</th>
                            <th {...this.purchasesHeader('price')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Precio</th>
                            <th {...this.purchasesHeader('discount')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Descuento</th>
                            {/* Precio final, ganancia y %ganancia se calculan acá en el front y no viajan en la
                                respuesta, así que el backend no las puede ordenar: van sin clase de orden. */}
                            <th aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Precio final</th>
                            <th {...this.purchasesHeader('cost')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Costo</th>
                            <th aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Ganancia bruta</th>
                            <th aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>%Ganancia</th>
                            <th {...this.purchasesHeader('status')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Estado</th>
                        </tr>
                    </thead>
                    {this.loadPurchases()}
                </table>

                <div className="containerLoader" style={{ display: this.state.loaded == true ? 'none' : 'block' }}>
                    <div className="loader"></div>
                </div>

                <PaginationComponent
                    totalItems={this.state.totalPurchases}
                    quantityRows={this.state.quantityShowRowsPurchases}
                    currentPage={this.state.currentPagePurchases}
                    onPageChange={(page) => this.fetchData({ purchasePage: page })}
                />
            </div>
        </div>;
    }

    renderRestockings = () => {
        return <div>
            <h5 style={{ color: '#3d5170', fontWeight: 600, marginTop: '2rem', marginBottom: '1rem' }}>Restocks</h5>
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows_res" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRowsRestockings} onChange={() => this.onChangeShowRowsRestocking()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search_restockings" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchRestockingsInput} onChange={(e) => this.onChangeInputRestockings(e.target.value)}/>
                    </label>
                </div>
                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            <th {...this.restockingsHeader('id')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Reposicion</th>
                            <th {...this.restockingsHeader('date')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Fecha</th>
                            <th {...this.restockingsHeader('quantity')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '5%' }}>Unidades</th>
                            <th {...this.restockingsHeader('unitPrice')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Precio</th>
                            <th {...this.restockingsHeader('provider')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Proveedor</th>
                            <th {...this.restockingsHeader('paymentStatus')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '10%' }}>Estado de pago</th>
                        </tr>
                    </thead>
                    {this.loadRestockings()}
                </table>

                <div className="containerLoader" style={{ display: this.state.loaded == true ? 'none' : 'block' }}>
                    <div className="loader"></div>
                </div>

                <PaginationComponent
                    totalItems={this.state.totalRestockings}
                    quantityRows={this.state.quantityShowRowsRestockings}
                    currentPage={this.state.currentPageRestockings}
                    onPageChange={(page) => this.fetchData({ restockingPage: page })}
                />
            </div>
        </div>;
    }

    render() {
        return (
            <>
                <style>{`
                    .summary-shimmer {
                        filter: saturate(0.92);
                    }

                    @keyframes summaryShimmer {
                        0% {
                            background-position: 200% 0;
                        }
                        100% {
                            background-position: -200% 0;
                        }
                    }
                `}</style>
                <div>
                {this.renderPurchasesStatistics()}
                {this.renderPurchases()}
                {this.renderRestockings()}
                </div>
            </>
        );
    }
}

export default AnalyticsComponent;
